(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pet-landing"] && !Shopify.designMode) return;
  try {
    

function initPetSales(scope = document) {
  scope.querySelectorAll('.pet-page').forEach(page => {
    if (page.dataset.petReady) return;
    page.dataset.petReady = 'true';
    const mainImage = page.querySelector('.pet-main-image');
    const showImage = src => {
      if (!mainImage || !src) return;
      mainImage.src = src;
      mainImage.removeAttribute('srcset');
      page.querySelectorAll('.pet-thumb').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.image === src)));
    };
    page.querySelectorAll('.pet-thumb').forEach(button => button.addEventListener('click', () => showImage(button.dataset.image)));
    const updatePrice = () => {
      const variant = page.querySelector('input[name="id"]:checked');
      const quantity = page.querySelector('input[name="quantity"]:checked')?.value || '1';
      if (!variant) return;
      page.querySelectorAll('[data-pet-price], [data-pet-sticky-price]').forEach(price => price.textContent = variant.dataset['price' + quantity]);
      page.querySelectorAll('[data-quantity-price]').forEach(price => price.textContent = variant.dataset['price' + price.dataset.quantityPrice]);
    };
    page.querySelectorAll('input[name="id"]').forEach(input => input.addEventListener('change', () => { updatePrice(); showImage(input.dataset.image); }));
    page.querySelectorAll('input[name="quantity"]').forEach(input => input.addEventListener('change', updatePrice));
    page.querySelectorAll('.pet-result-range').forEach(input => input.addEventListener('input', () => input.closest('.pet-media-section').querySelector('.pet-before-after').style.setProperty('--reveal', input.value + '%')));
    const purchase = page.querySelector('.pet-add');
    const sticky = page.querySelector('.pet-mobile-cta');
    if (purchase && sticky && 'IntersectionObserver' in window) {
      new IntersectionObserver(entries => sticky.classList.toggle('pet-cta-hidden', entries[0].isIntersecting), { threshold: 0 }).observe(purchase);
    }
    const dialog = page.querySelector('.pet-cart-dialog');
    const form = purchase?.closest('form');
    if (!dialog || !form || !dialog.showModal) return;
    page.querySelectorAll('.pet-cart-close, .pet-cart-continue').forEach(button => button.addEventListener('click', () => dialog.close()));
    dialog.addEventListener('click', event => { if (event.target === dialog && event.clientX < dialog.getBoundingClientRect().left) dialog.close(); });
    form.addEventListener('submit', async event => {
      event.preventDefault();
      if (purchase.disabled) return;
      const label = purchase.textContent;
      const status = page.querySelector('.pet-cart-status');
      purchase.disabled = true;
      purchase.textContent = page.dataset.loading;
      status.textContent = '';
      try {
        const added = await fetch(form.action + '.js', { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) });
        const result = await added.json();
        if (!added.ok) throw new Error(result.description || page.dataset.error);
        const response = await fetch(page.dataset.cartUrl + '.js', { headers: { Accept: 'application/json' } });
        if (!response.ok) throw new Error(page.dataset.error);
        const cart = await response.json();
        const money = cents => new Intl.NumberFormat(document.documentElement.lang || 'en-US', { style: 'currency', currency: cart.currency }).format(cents / 100);
        const items = page.querySelector('.pet-cart-items');
        items.replaceChildren();
        for (const item of cart.items) {
          const line = document.createElement('div'); line.className = 'pet-cart-line';
          const image = document.createElement('img'); if (item.image) image.src = item.image; image.alt = item.product_title;
          const copy = document.createElement('div');
          const title = document.createElement('p'); title.textContent = item.product_title;
          const detail = document.createElement('small'); detail.textContent = (item.variant_title || '') + ' · ' + item.quantity + ' × ' + money(item.final_price);
          copy.append(title, detail); line.append(image, copy); items.append(line);
        }
        page.querySelector('[data-cart-subtotal]').textContent = money(cart.items_subtotal_price);
        const cartLink = page.querySelector('.pet-nav a[href="' + page.dataset.cartUrl + '"]');
        if (cartLink) cartLink.textContent = cartLink.textContent.replace(/\(\d+\)/, '(' + cart.item_count + ')');
        status.textContent = page.dataset.added;
        dialog.showModal();
      } catch (error) {
        status.textContent = error.message || page.dataset.error;
      } finally {
        purchase.disabled = false;
        purchase.textContent = label;
      }
    });
  });
}
initPetSales();
document.addEventListener('shopify:section:load', event => initPetSales(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pet-sales-landing"] && !Shopify.designMode) return;
  try {
    
function initFurzelioLanding(scope = document) {
  scope.querySelectorAll('.pet-page').forEach(page => {
    if (page.dataset.petReady) return;
    page.dataset.petReady = 'true';
    page.querySelectorAll('.pet-result-range').forEach(input => input.addEventListener('input', () => input.closest('.pet-media-section').querySelector('.pet-before-after').style.setProperty('--reveal', input.value + '%')));
    const purchase = page.querySelector('.pet-quick-buy');
    if (purchase) {
      const image = purchase.querySelector('.pet-selected-image');
      const color = purchase.querySelector('[data-pet-color]');
      const updateColor = input => {
        if (!input || !image) return;
        image.srcset = input.dataset.colorSrcset;
        image.src = input.dataset.colorImage;
        image.alt = 'Furzelio Pet Mist Grooming Brush — ' + input.dataset.colorTitle;
        if (color) color.textContent = input.dataset.colorTitle;
      };
      purchase.querySelectorAll('input[name="id"]').forEach(input => input.addEventListener('change', () => updateColor(input)));
      updateColor(purchase.querySelector('input[name="id"]:checked'));
    }
    const primary = page.querySelector('.pet-intro .pet-button');
    const sticky = page.querySelector('.pet-mobile-cta');
    if (primary && sticky && 'IntersectionObserver' in window) {
      new IntersectionObserver(entries => sticky.classList.toggle('pet-cta-hidden', entries[0].isIntersecting), { threshold: 0 }).observe(primary);
    }
  });
}
initFurzelioLanding();
document.addEventListener('shopify:section:load', event => initFurzelioLanding(event.target));

  } catch(e) { console.error(e); }
})();
})();
